import { useState } from 'react';
import PropTypes from 'prop-types';
import QuestionStyle from '../questionStyle';
import AddAttributeQuestions from '../addAttributeQuestions';
import { isArrayEmpty } from '../../../utility/helpers';

const AttributeQuestionsForm = ({
  translations,
  values,
  initialValues,
  setDialogVisibility,
  dialogs,
  field,
  updateAttributeQuestions,
  hasError = {},
}) => {
  const [horizontalWarnings, setHorizontalWarnings] = useState([]);
  const [isQuestionView, setIsQuestionView] = useState(true);

  const isWarningOn = !isArrayEmpty(horizontalWarnings);
  const isEditDisabled = !isQuestionView || !values.is_editable;

  const handleHorizontalWarning = questionId => {
    setHorizontalWarnings(prevWarnings => {
      const index = prevWarnings.indexOf(questionId);

      if (index > -1) {
        return prevWarnings.filter(warning => warning !== questionId);
      }
      return [...prevWarnings, questionId];
    });
  };

  return (
    <>
      <QuestionStyle
        key={field.questionsStyleComponent.name}
        fieldData={field.questionsStyleComponent}
        translations={translations}
        setDialogVisibility={setDialogVisibility}
        dialogs={dialogs}
        attribute={values}
        updateAttributeQuestions={updateAttributeQuestions}
        isWarningOn={isWarningOn}
        isEditDisabled={isEditDisabled}
      />
      <AddAttributeQuestions
        key={field.attributeQuestions.name}
        translations={translations.questionsForm}
        attribute={values}
        updateAttributeQuestion={updateAttributeQuestions}
        hasError={hasError}
        dialogs={dialogs}
        setDialogVisibility={setDialogVisibility}
        switchHorizontalWarning={handleHorizontalWarning}
        isQuestionView={isQuestionView}
        isEditDisabled={isEditDisabled}
        initialAttribute={initialValues}
        onChangeQuestionView={val => setIsQuestionView(val)}
      />
    </>
  );
};

AttributeQuestionsForm.propTypes = {
  translations: PropTypes.object.isRequired,
  field: PropTypes.object.isRequired,
  values: PropTypes.object.isRequired,
  setDialogVisibility: PropTypes.func.isRequired,
  dialogs: PropTypes.object.isRequired,
  updateAttributeQuestions: PropTypes.func.isRequired,
  hasError: PropTypes.object,
  initialValues: PropTypes.object.isRequired,
};

export default AttributeQuestionsForm;
